import { render } from "./MainLoader.vue?vue&type=template&id=77248b92&ts=true"
import script from "./MainLoader.ts?vue&type=script&lang=ts"
export * from "./MainLoader.ts?vue&type=script&lang=ts"

import "./MainLoader.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/r1/a/_rdt_web_telemedicina_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QSpinnerDots});
